<sdps-notification type="error" class="sdps-m-top_none" *ngIf="((sharedService.errorMessage | async) || (sharedService.userNameMsg | async)|| (sharedService.userActionMsg | async)|| (sharedService.userTimeMsg | async)|| (sharedService.userBrowserMsg | async))">
  <div class="sdps-notification__text">
    <p [innerHTML]="sharedService.errorMessage | async"></p>
   </div>
</sdps-notification>
<div class="toastController" *ngIf="inActiveHistoricalView && sharedService.currentModeForRulesOrMangeGrps !== 'EDIT'">
  <sdps-notification type="warning" class="sdps-m-top_none" *ngIf="inActiveHistoricalView"
    id="information-alert" sr-close-button-label="information alert label"
    sr-icon-label="information alert icon label">
    <div class="sdps-notification__text">
      <p class="sdps-notification__title" [innerHTML]="this.sharedConst.historicalViewWarnMsg"></p>
    </div>
  </sdps-notification>
</div>
